import { getUrls } from "../../utils/urls";
import useApiWrapper from "./useApiWrapper";

const useLandingAuthApi = () => {
  const { fetchWithAuth } = useApiWrapper();
  const URLS = getUrls();

  const fetchAllTrips = async (pageNo, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.GET_ALL_TRIP}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const approveEscort = async (tripId, escortData) => {
    return await fetchWithAuth(URLS.APPROVE_ESCORT(tripId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(escortData),
    });
  };
  const getDocument = async (passengerId) => {
    return await fetchWithAuth(URLS.GET_DOCUMENT + passengerId, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const rejectEscort = async (tripId, reasonForRejection) => {
    return await fetchWithAuth(URLS.REJECT_ESCORT(tripId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reasonForRejection),
    });
  };
  const correctionNeededEscort = async (tripId, reasonForCorrection) => {
    return await fetchWithAuth(URLS.CORRECTION_NEEDED_ESCORT(tripId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reasonForCorrection),
    });
  };
  const approveAfterHours = async (tripId, afterHoursData) => {
    return await fetchWithAuth(URLS.APPROVE_AFTER_HOURS(tripId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(afterHoursData),
    });
  };
  const rejectAfterHours = async (tripId, reasonForRejection) => {
    return await fetchWithAuth(URLS.REJECT_AFTER_HOURS(tripId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reasonForRejection),
    });
  };
  const approveTrip = async (tripId) => {
    const finalUrl = `${URLS.APPROVE_TRIP(tripId)}`;
    return await fetchWithAuth(finalUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const exemptTrip = async (tripId, exemptionReason) => {
    const finalUrl = `${URLS.EXEMPT_TRIP(tripId)}`;
    return await fetchWithAuth(finalUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(exemptionReason),
    });
  };
  const correctionNeededTrip = async (tripId, reasonForCorrection) => {
    const queryParams = new URLSearchParams();
    queryParams.append("correctionReason", reasonForCorrection.correctionReason);
    const finalUrl = `${URLS.CORRECTION_NEEDED_TRIP(
      tripId
    )}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const addEscortOfficers = async (tripId, tripPhase, data) => {
    const queryParams = new URLSearchParams();
    queryParams.append("tripPhase", tripPhase);
    const finalUrl = `${URLS.ADD_ESCORT_OFFICERS(
      tripId
    )}?${queryParams.toString()}`;
    return await fetchWithAuth(finalUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  };
  const addAfterHoursOfficers = async (tripId, tripPhase, data) => {
    const queryParams = new URLSearchParams();
    queryParams.append("tripPhase", tripPhase);
    const finalUrl = `${URLS.ADD_AFTER_HOURS_OFFICERS(
      tripId
    )}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  };
  const getTripById = async (tripId) => {
    const finalUrl = `${URLS.GET_TRIP(tripId)}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const getTripFee = async (tripId) => {
    const finalUrl = `${URLS.GET_TRIP_FEE(tripId)}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const searchByTrackingId = async (searchText) => {
    const queryParams = new URLSearchParams();
    queryParams.append("searchInput", searchText);
    const finalUrl = `${URLS.SEARCH_TRIP_FEE}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const searchHistoricTrip = async (searchText) => {
    const queryParams = new URLSearchParams();
    queryParams.append("searchInput", searchText);
    const finalUrl = `${URLS.SEARCH_HISTORIC_TRIP}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchListOfAirport = async () => {
    return await fetchWithAuth(URLS.LIST_OF_AIRPORT);
  };

  const fetchHistoricTrips = async (pageNo, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.GET_HISTORIC_TRIP}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchHistoricTripByFilters = async (pageNo, size, filters) => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    if (filters.selectedArrivalAirport) {
      queryParams.append("arrivalAirportId", filters.selectedArrivalAirport);
    }

    if (filters.selectedDepartureAirport) {
      queryParams.append(
        "departureAirportId",
        filters.selectedDepartureAirport
      );
    }

    if (filters.selectedDateFrom) {
      queryParams.append(
        "departureDate",
        filters.selectedDateFrom.format("YYYY-MM-DD")
      );
    }

    if (filters.selectedStatus === "EXEMPTED") {
      queryParams.append("isExempted", true);
    } else if (filters.selectedStatus) {
      queryParams.append("tripStatus", filters.selectedStatus);
    }

    if (filters.registrationNumber?.trim()) {
      queryParams.append(
        "registrationNumber",
        filters.registrationNumber.trim()
      );
    }

    const finalUrl = `${URLS.GET_HISTORIC_TRIP_BY_FILTERS
      }?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const getAircraftById = async (aircraftTypeId) => {
    const finalUrl = `${URLS.GET_AIRCRAFT_BY_ID(aircraftTypeId)}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchTripByFilters = async (filterData) => {
    const queryParams = new URLSearchParams();

    queryParams.append("page", filterData.page);
    queryParams.append("size", filterData.size);

    if (filterData.arrivalAirportId) {
      queryParams.append("arrivalAirportId", filterData.arrivalAirportId);
    }

    if (filterData.departureAirportId) {
      queryParams.append("departureAirportId", filterData.departureAirportId);
    }

    if (filterData.departureDate) {
      queryParams.append("departureDate", filterData.departureDate);
    }

    if (filterData.createdByAdsb !== undefined) {
      queryParams.append("createdByAdsb", filterData.createdByAdsb);
    }

    if (filterData.registrationNumber) {
      queryParams.append(
        "registrationNumber",
        filterData.registrationNumber
      );
    }

    const finalUrl = `${URLS.GET_TRIP_BY_FILTERS}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const addDeviceToken = async (deviceToken) => {
    return await fetchWithAuth(`${URLS.ADD_DEVICE_TOKEN}?deviceToken=${deviceToken}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const removeDeviceToken = async () => {
    return await fetchWithAuth(`${URLS.REMOVE_DEVICE_TOKEN}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchUserProfile = async () => {
    return await fetchWithAuth(`${URLS.USER_PROFILE}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      handle404: true
    });
  };
  const fetchAllOverTimeTrips = async (pageNo, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.GET_OVERTIME_LIST}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchAllEscortTrips = async (pageNo, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.GET_ESCORT_LIST}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
  const fetchOfficersByAirport = async (airportId) => {
    return await fetchWithAuth(`${URLS.GET_OFFICERS_BY_AIRPORT}/${airportId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchInAppNotification = async (page, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", page);
    queryParams.append("size", size);

    queryParams.append("platformProfileType", "AA_USER");
    queryParams.append("platformType", "LANDING_AUTH_APP");

    return await fetchWithAuth(`${URLS.GET_IN_APP_NOTIFICATION}?${queryParams.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const markNotificationAsRead = async (notificationId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("platformProfileType", "AA_USER");
    queryParams.append("platformType", "LANDING_AUTH_APP");

    return await fetchWithAuth(`${URLS.MARK_NOTIFICATION_AS_READ(notificationId)}?${queryParams.toString()}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const markAllNotificationsAsRead = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("platformProfileType", "AA_USER");
    queryParams.append("platformType", "LANDING_AUTH_APP");

    return await fetchWithAuth(
      `${URLS.READ_ALL_NOTIFICATIONS}?${queryParams.toString()}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  };

  const deleteNotification = async (notificationId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("platformProfileType", "AA_USER");
    queryParams.append("platformType", "LANDING_AUTH_APP");

    return await fetchWithAuth(`${URLS.DELETE_NOTIFICATION(notificationId)}?${queryParams.toString()}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };


  const fetchUnreadNotificationCount = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("platformProfileType", "AA_USER");
    queryParams.append("platformType", "LANDING_AUTH_APP");

    return await fetchWithAuth(`${URLS.GET_UNREAD_NOTIFICATION_COUNT}?${queryParams.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchUnreadNotifications = async (notificationId) => {
    const queryParams = new URLSearchParams();
    queryParams.append("platformProfileType", "AA_USER");
    queryParams.append("platformType", "LANDING_AUTH_APP");

    return await fetchWithAuth(`${URLS.GET_UNREAD_NOTIFICATIONS(notificationId)}?${queryParams.toString()}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const searchAirport = async (searchData) => {
    const queryParams = new URLSearchParams(searchData).toString();
    return await fetchWithAuth(`${URLS.SEARCH_AIRPORT}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchUnregisteredAircraftTrips = async (pageNo, size) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.GET_UNREGISTERED_AIRCRAFT_TRIPS}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const fetchUnregisteredAircraftTripsByRegistration = async (
    aircraftRegistrationNumber,
    arrivalAirportId,
    pageNo = 0,
    size = 10
  ) => {
    const queryParams = new URLSearchParams();
    queryParams.append("aircraftRegistrationNumber", aircraftRegistrationNumber);
    queryParams.append("arrivalAirportId", arrivalAirportId);
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.GET_UNREGISTERED_AIRCRAFT_TRIPS_BY_REGISTRATION}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const searchUnregisteredAircraftTrips = async (
    aircraftRegistrationNumber,
    pageNo = 0,
    size = 10
  ) => {
    const queryParams = new URLSearchParams();
    queryParams.append("aircraftRegistrationNumber", aircraftRegistrationNumber);
    queryParams.append("page", pageNo);
    queryParams.append("size", size);

    const finalUrl = `${URLS.SEARCH_UNREGISTERED_AIRCRAFT_TRIPS}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const getAirportById = async (airportId) => {
    const finalUrl = `${URLS.GET_AIRPORT_BY_ID(airportId)}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const exportUnregisteredAircraftTripsByRegistration = async (
    aircraftRegistrationNumber, arrivalAirportId,
  ) => {
    const queryParams = new URLSearchParams();
    queryParams.append("aircraftRegistrationNumber", aircraftRegistrationNumber);
    queryParams.append("arrivalAirportId", arrivalAirportId);

    const finalUrl = `${URLS.EXPORT_UNREGISTERED_AIRCRAFT_TRIPS_BY_REGISTRATION}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const exportUnregisteredAircraftTrips = async (fromDate, toDate) => {
    const queryParams = new URLSearchParams();
    queryParams.append("fromDate", fromDate);
    queryParams.append("toDate", toDate);

    const finalUrl = `${URLS.EXPORT_UNREGISTERED_AIRCRAFT_TRIPS}?${queryParams.toString()}`;

    return await fetchWithAuth(finalUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  const exportUpcomingTrips = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return fetchWithAuth(`${URLS.EXPORT_UPCOMING}?${queryParams}`, {
      method: "GET",
      responseType: "blob",
    });
  };
  const exportHistoricTrips = async (data) => {
    const queryParams = new URLSearchParams(data).toString();
    return fetchWithAuth(`${URLS.EXPORT_HISTORIC_TRIPS}?${queryParams}`, {
      method: "GET",
      responseType: "blob",
    });
  };

  return {
    fetchAllTrips,
    approveEscort,
    rejectEscort,
    correctionNeededEscort,
    approveAfterHours,
    rejectAfterHours,
    approveTrip,
    correctionNeededTrip,
    exemptTrip,
    getDocument,
    addEscortOfficers,
    addAfterHoursOfficers,
    getTripById,
    getTripFee,
    searchByTrackingId,
    fetchListOfAirport,
    fetchHistoricTrips,
    getAircraftById,
    fetchHistoricTripByFilters,
    fetchTripByFilters,
    addDeviceToken,
    removeDeviceToken,
    fetchUserProfile,
    fetchAllOverTimeTrips,
    fetchAllEscortTrips,
    fetchOfficersByAirport,
    fetchInAppNotification,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    deleteNotification,
    fetchUnreadNotificationCount,
    fetchUnreadNotifications,
    searchHistoricTrip,
    searchAirport,
    fetchUnregisteredAircraftTrips,
    fetchUnregisteredAircraftTripsByRegistration,
    searchUnregisteredAircraftTrips,
    exportUnregisteredAircraftTripsByRegistration,
    exportUnregisteredAircraftTrips,
    exportUpcomingTrips,
    exportHistoricTrips,
    getAirportById,

  };
};
export default useLandingAuthApi;

